var map = {
	"./Dignitary-Visit-1-300x225.jpg": 4430,
	"./Dignitary-Visit-10-300x225.jpg": 526,
	"./Dignitary-Visit-11-300x225.jpg": 8803,
	"./Dignitary-Visit-12-300x225.jpg": 3080,
	"./Dignitary-Visit-3-300x225.jpg": 7224,
	"./Dignitary-Visit-4-300x225.jpg": 3111,
	"./Dignitary-Visit-5-300x225.jpg": 3810,
	"./Dignitary-Visit-6-300x225.jpg": 5457,
	"./Dignitary-Visit-7-300x225.jpg": 5404,
	"./Dignitary-Visit-8-300x225.jpg": 7595,
	"./Dignitary-Visit-9-300x225.jpg": 9670,
	"./Dignitary-Visit-Kishor-Kanere-Ex-Shivsena-Leader-300x225.jpg": 9466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7213;